"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAsDate = exports.parseAge = void 0;
const luxon_1 = require("luxon");
const parseAge = (birthday) => {
    if (!birthday) {
        return 0;
    }
    const realBirthday = new Date(birthday);
    const today = new Date();
    let age = today.getFullYear() - realBirthday.getFullYear();
    const referenceDate = new Date(today.getFullYear() - age, today.getMonth(), today.getDate());
    if (realBirthday > referenceDate) {
        age -= 1;
    }
    return age;
};
exports.parseAge = parseAge;
const getAsDate = (d) => {
    if (d instanceof luxon_1.DateTime) {
        return d;
    }
    if (typeof d === 'number') {
        return luxon_1.DateTime.fromMillis(d);
    }
    return luxon_1.DateTime.fromISO((d instanceof Date ? d.toISOString() : d === null || d === void 0 ? void 0 : d.toString()) || '');
};
exports.getAsDate = getAsDate;
//# sourceMappingURL=dates.js.map